import ApplicationController from './application_controller'

/**
 * Values:
 *  urlParam: The custom parameter to add in the URL for the search/filter
 *
 * EXAMPLE:
 *
 * <%= select_tag 'User',
       options_from_collection_for_select(User.all, 'id', 'name', params[:user_id]),
       data: {
        controller: 'search-selected-option',
        'search-selected-option-url-param-value': 'user_id',
        action: 'search-selected-option#search'
       }
  %>
 */

export default class extends ApplicationController {
  static values = {
    urlParam: String,
    resetPagination: Boolean
  }
  static targets = ['checkbox']

  search (e) {
    const paginationParams = [
      'pending_page',
      'incidents_page',
      'to_be_collected_page',
      'collection_requested_page',
      'collected_page',
      'received_page',
      'packed_page',
      'in_transit_page'
    ]
    const params = new URLSearchParams(window.location.search)
    let value = e.currentTarget.value

    params.set(this.urlParamValue, value)

    if (this.resetPaginationValue) {
      paginationParams.forEach((paramName) => params.delete(paramName))
    }

    window.location.replace(window.location.pathname + `?${params.toString()}`)
  }
}
